import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randBoolean } from '@ngneat/falso'
import type { SchemaAttributes } from '../types.js'

export type FeatureBlockData = SchemaAttributes<'FeatureBlock'>

export const model = Model as ModelDefinition<FeatureBlockData>

export const factory = Factory.extend<FeatureBlockData>({
  name(n) {
    return `Feature block ${n}`
  },
  visible() {
    return randBoolean()
  },
})
